export default {
  user: {},
  accessControl: undefined,
  accessControlRoleIds: [],
  securityPolicy: {},
};
